export default __webpack_public_path__ + "static/mockStress3-abe686e8a720836d45b4a7dba2691d34.png";